import Icon, { Icons } from '@/components/elements/Icon';
import { Action } from '../types';
import { useTranslations } from 'use-intl';
import { TransactionCancelledError } from 'nftx.js';

type Props = Action;

const IndexIcon = ({ index }: { index: number }) => {
  return (
    <span className="bg-gray-300 p-1 rounded-md mr-2 w-6 h-6 inline-flex items-center justify-center text-sm font-medium">
      {index + 1}
    </span>
  );
};

const ActionItemStatus = ({ status, index, error }: Props) => {
  const t = useTranslations('ActionList');
  if (status === 'Success') {
    return (
      <div className="bg-green-500 text-gray-50 px-1 py-0.5 rounded-md inline-flex justify-center items-center text-sm uppercase font-medium">
        <Icon name={Icons.CHECK_CIRCLE} size={24} className="mr-1" />
        <span className="mr-1">{t('item.success')}</span>
      </div>
    );
  }

  if (status === 'PendingSignature' || status === 'Mining') {
    return (
      <div className="inline-flex items-center">
        <IndexIcon index={index} />
        <Icon
          name={Icons.SPINNER_GAP}
          size={20}
          className="animate-spin inline-block"
        />
      </div>
    );
  }

  if (error) {
    if (error instanceof TransactionCancelledError) {
      return (
        <div className="inline-flex items-center">
          <IndexIcon index={index} />
          <Icon
            name={Icons.EXCLAMATION_TRIANGLE}
            className="text-yellow-400"
            size={24}
          />
        </div>
      );
    }

    return (
      <div className="inline-flex items-center">
        <IndexIcon index={index} />
        <Icon
          name={Icons.EXCLAMATION_TRIANGLE}
          className="text-red-500"
          size={24}
        />
      </div>
    );
  }

  return <IndexIcon index={index} />;
};

export const ActionItem = (action: Props) => {
  const { label } = action;

  const inProgress = action.status !== 'None' && action.status !== 'Success';

  return (
    <li className="border border-gray-300 rounded-xl p-2 flex justify-between items-center">
      <ActionItemStatus {...action} />
      <div
        className={`text-sm ${
          inProgress ? 'font-bold text-gray-800' : 'text-gray-500'
        }`}
      >
        {label}
      </div>
    </li>
  );
};

export default ActionItem;
